export function isOibValid(oib?: string | null): boolean {
  if (!oib) return false;

  const clean = oib.trim();

  // SQL:
  // if(len(@OIB) = 11 AND @oib like '9999999999_' AND ISNUMERIC(last char))
  if (
    clean.length === 11 &&
    /^9999999999\d$/.test(clean)
  ) {
    return true;
  }

  // SQL: patindex('%[^0123456789]%', @oib) > 0
  if (!/^\d+$/.test(clean)) return false;

  // SQL: LEN(@oib) <> 11
  if (clean.length !== 11) return false;

  let x = 0;
  const kontrolni = Number(clean.substring(10, 11));

  for (let i = 0; i < 10; i++) {
    const digit = Number(clean[i]);

    if (i === 0) {
      x = digit + 10;
    } else {
      x = x + digit;
    }

    x = x % 10;
    if (x === 0) x = 10;
    x = (x * 2) % 11;
  }

  x = 11 - x;
  if (x > 9) x = 0;

  return kontrolni === x;
}
